import { useState } from 'react';
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

/** Hamburger trigger + drawer that hosts the existing Sidebar.
 *  Auto-closes on route change so the user doesn't have to tap twice. */
export function MobileNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden -ml-2" aria-label="Otevřít menu">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="p-0 w-72 max-w-[85vw]">
        <SheetTitle className="sr-only">Navigace</SheetTitle>
        <Sidebar />
      </SheetContent>
    </Sheet>
  );
}
